import type { ReCaptchaInstance } from 'recaptcha-v3'

let recaptcha: ReCaptchaInstance

export default async function useRecaptcha() {
  if (!recaptcha && isMetaClient) {
    const runtimeConfig = useRuntimeConfig()
    const load = (await import('recaptcha-v3')).load

    recaptcha = await load(runtimeConfig.public.recaptcha.siteId, {
      useEnterprise: true,
      autoHideBadge: true,
    })
  }

  return recaptcha
}
